export const handleWebSocketData = (data, setData) => {
  const parsedData = JSON.parse(data);
  
  const deepMerge = (target, source) => {
    Object.keys(source).forEach(key => {
      if (typeof source[key] === 'object' && source[key] !== null) {
        if (!target[key]) target[key] = {};
        deepMerge(target[key], source[key]);
      } else {
        target[key] = source[key];
      }
    });
  };

  setData(prevData => {
    const newData = { ...prevData };
    deepMerge(newData, parsedData);
    return newData;
  });
};
